import LegalityKey, { LEGALITY_COLORS } from './LegalityKey/LegalityKey'

import { INTERNAL_FORMAT_NAME, HUMAN_READABLE_FORMAT } from 'types/deck'
import { Legality as LegalityType } from 'services/apiTypes/card.types'

import styles from './legality.module.scss'

type Props = {
  legalities: Record<string, LegalityType>
}

const Legality = ({ legalities }: Props) => (
  <div className={styles.container}>
    <div>
      Legalities: <LegalityKey />
    </div>

    <div className={styles.legalities}>
      {Object.keys(INTERNAL_FORMAT_NAME).map((format, i) => {
        const formatId = INTERNAL_FORMAT_NAME[format]

        if (format === 'custom') return null

        const backgroundColor = LEGALITY_COLORS[legalities[format]]

        return (
          <label key={i} style={{ backgroundColor }} className={styles.label}>
            {HUMAN_READABLE_FORMAT[formatId]}
          </label>
        )
      })}
    </div>
  </div>
)

export default Legality
